import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCollaborationPointerRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCollaborationPointerRight"><Path d="M11.5 12.5L4 9.5L19.5 4.5L14.5 20L11.5 12.5Z" stroke="currentColor"/><Path d="M3 13.2998L8.5 15.4998L10.7 20.9998" stroke="currentColor"/></CentralIconBase>;
});

export default IconCollaborationPointerRight;
